import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultNoValueText: {
		id: 'issue-field-date-time.default-no-value-text',
		defaultMessage: 'None',
		description: 'Default text shown when no date has been set',
	},
});
